export const BG_IMG =
    "https://www.nykaafashion.com/pub/static/frontend/Nykaa/theme001/en_US/images/sbscribeImg.png";

export const TEXT = {
    INFO: "Do you wish to subscribe to our exciting offers and marketing promotions?",
    OPT_IN: "Yes",
    OPT_OUT: "No, Thank you",
    POLICY_TEXT: (link: string, link2: string) =>
        `Please refer to our <a href="${link}">Privacy Policy</a> for EU Residents and <a href="${link2}">Terms &amp; Conditions</a>`,
};

export const IMG_WIDTH = 371;

export const SHOW_NEWS_LETTER = "2";

export const NEWS_SUBSCRIPTION = {
    YES: 1,
    NO: 0,
};
